module.exports = __webpack_public_path__ + "img/sketch-black-start.f803bec8.png";